import { FC } from "react";
import { HIGHLIGHT_CONFIG } from "./highlights";
import { cn } from "@/lib/utils";

interface HighlightButtonProps {
  highlight: (typeof HIGHLIGHT_CONFIG)[number];
  isActive: boolean;
  onSelect: (highlight: (typeof HIGHLIGHT_CONFIG)[number]) => void;
  className?: string;
}

export const HighlightButton: FC<HighlightButtonProps> = ({
  highlight,
  isActive,
  onSelect,
  className,
}) => {
  const Icon = highlight.icon;

  return (
    <button
      type="button"
      onClick={() => onSelect(highlight)}
      className={cn(
        "group relative inline-flex h-8 px-3 group-data-[collapsible=icon]:flex group-data-[collapsible=icon]:flex-col group-data-[collapsible=icon]:py-0 items-center gap-1.5 rounded-full",
        "text-xs font-medium transition duration-150 ease-out",
        highlight.color.text,
        highlight.color.bg,
        highlight.color.hoverBg,
        isActive && "ring-2 ring-offset-2",
        isActive && highlight.color.border.replace("border-", "ring-"),
        className
      )}
    >
      <Icon
        className="
            h-3.5 w-3.5
            transition-transform duration-150
            group-hover:scale-105
          "
      />
      <span className="group-data-[collapsible=icon]:hidden">
        {highlight.label}
      </span>
    </button>
  );
};
